const VAPID_PUBLIC_KEY = 'BNuriZzzHzaWv8jfelB1HTNyTnH_bp7ixVTxsKdL87yqYQwjaq3lHCQhFR4xwLo9Oi-OHvvNmKjAZpAcHjDLhSo';
import store from './store'

import { register } from 'register-service-worker'

// Service Worker auch im Development-Modus registrieren für Push-Notifications
register(`${process.env.BASE_URL}service-worker.js`, {
  ready () {
    console.log(
      'App is being served from cache by a service worker.\n' +
      'For more details, visit https://goo.gl/AFskqB'
    )
  },
  registered () {
    console.log('Service worker has been registered.')
  },
  cached () {
    console.log('Content has been cached for offline use.')
  },
  updatefound () {
    console.log('New content is downloading.')
  },
  updated (registration) {
    console.log('New content is available; triggering update.')
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
  offline () {
    console.log('No internet connection found. App is running in offline mode.')
  },
  error (error) {
    console.error('Error during service worker registration:', error)
  }
})

let refreshing = false;
navigator.serviceWorker.addEventListener('controllerchange', () => {
  if (refreshing) return;
  refreshing = true;
  window.location.reload();
});


function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

  const rawData = atob(base64);
  return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
}

export default async function registerPushWorker() {
  // iOS-spezifische Checks
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  const isSecureContext = window.isSecureContext && (location.protocol === 'https:' || location.hostname === 'localhost');
  
  console.log('🔍 Push-Detection:', {
    isIOS,
    isStandalone,
    isSecureContext,
    permission: Notification.permission,
    serviceWorkerSupport: 'serviceWorker' in navigator,
    pushManagerSupport: 'PushManager' in window
  });
  
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push-Benachrichtigungen werden nicht unterstützt.');
    return;
  }

  if (!isSecureContext) {
    console.warn('🔒 HTTPS erforderlich für Push-Notifications');
    return;
  }

  // Auf iOS erst prüfen, ob als PWA installiert
  if (isIOS && !isStandalone) {
    console.warn('🍎 iOS: App muss als PWA installiert sein für Push-Notifications.');
    console.info('💡 Lösung: Füge die App zum Homescreen hinzu (Safari → Share → Add to Home Screen)');
    return;
  }

  try {
    // Längere Wartezeit für iOS - Service Worker muss voll initialisiert sein
    await new Promise(resolve => {
      if (navigator.serviceWorker.controller) {
        // Auf iOS nochmal warten
        setTimeout(resolve, isIOS ? 3000 : 500);
      } else {
        const timeout = setTimeout(resolve, isIOS ? 5000 : 2000);
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          clearTimeout(timeout);
          setTimeout(resolve, isIOS ? 2000 : 0);
        }, { once: true });
      }
    });
    
    const registration = await navigator.serviceWorker.ready;
    console.log('✅ Service Worker registriert:', registration);

    // Berechtigung prüfen/anfragen (auch auf iOS versuchen)
    let permission = Notification.permission;
    
    if (permission === 'default') {
      console.log('📱 Fordere Push-Berechtigung an...');
      
      // iOS-kompatible Permission-Anfrage
      permission = await new Promise((resolve) => {
        if (Notification.requestPermission.length === 0) {
          // Promise-based API (moderner Browser)
          Notification.requestPermission().then(resolve);
        } else {
          // Callback-based API (ältere iOS-Versionen)
          Notification.requestPermission(resolve);
        }
      });
    }
    
    if (permission !== 'granted') {
      console.warn('🔒 Benachrichtigungsberechtigung nicht erteilt:', permission);
      return;
    }

    console.log('✅ Push-Berechtigung erhalten!');

    // Bestehende Subscription prüfen
    let subscription = await registration.pushManager.getSubscription();
    console.log(subscription)

    if (!subscription) {
      // Neue Subscription erstellen
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
      console.log('📬 Neue Subscription erstellt:', subscription);
    } else {
      console.log('📬 Bestehende Subscription gefunden:', subscription);
    }

    // Subscription an dein Backend senden
    await fetch((process.env.NODE_ENV === 'production' ? 'https://dumm-gehen-api.dumm-gmbh.de/api/subscribe' : 'http://localhost:3002/api/subscribe'), {
      method: 'POST',
      body: JSON.stringify(subscription),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${store.state.token}`,
      },
    });

    console.log('✅ Subscription an Backend gesendet.');
  } catch (error) {
    console.error('❌ Fehler bei der Registrierung oder Subscription:', error);
    
    // iOS-spezifische Fehlermeldungen
    if (isIOS && !isStandalone) {
      console.info('💡 Lösung: Füge die App zum Homescreen hinzu (Safari → Share → Add to Home Screen)');
    }
  }
}

// Exportiere auch eine Funktion zur manuellen Aktivierung (User-initiated für iOS)
export async function requestPushPermission() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  
  console.log('🔔 Manuelle Push-Permission angefragt (User-initiated)');
  
  if (isIOS) {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!isStandalone) {
      alert('Für Push-Benachrichtigungen muss die App als PWA installiert sein.\n\nSafari → Share → "Add to Home Screen"');
      return false;
    }
  }
  
  try {
    // Explizite Permission-Anfrage (User-triggered für iOS)
    const permission = await new Promise((resolve) => {
      if (Notification.requestPermission.length === 0) {
        // Promise-based API
        Notification.requestPermission().then(resolve);
      } else {
        // Callback-based API (iOS)
        Notification.requestPermission(resolve);
      }
    });
    
    if (permission === 'granted') {
      console.log('✅ Permission erhalten, registriere Push-Worker...');
      await registerPushWorker();
      return true;
    } else {
      console.warn('❌ Permission verweigert:', permission);
      return false;
    }
  } catch (error) {
    console.error('❌ Fehler bei manueller Push-Permission:', error);
    return false;
  }
}
